module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADvSURBVHgBjVFtDYMwEIXS/8PBmIPigDkABdsUDCTgAAsomIThYEioBATwsffItYGEZLvkcr3Pd/caBpCyLGOl1DMMwwxuIkoZoP2yLO08z13TNFYzGkXRZ1O0lRiacZDWusc7VZI4Kt4JUAytEsf+0WB9AyArmJb7HtRa5GvcUPgGyItDoPU0TSn0AhJWixiHnXDnm4VaGsjGnYrEGsDEwL2xjodzCO2POwZZ2yOcMfEK6hJYshG7QqzWj+No+U/bhhzwOY/GJAu0wQ2C3pAz4leugewY4dqgye/i9t/RCjYKBB54dkKAExZ1QmvKwBdT62oVIg/H4AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/automation/data_manager_lite.png
// module id = 9BTT
// module chunks = 46